/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from "react";
import {
  Container,
  Button,
  Grid,
  Breadcrumbs,
  Link,
  Typography,
  CircularProgress,
  Backdrop,
} from "@material-ui/core";
import _ from "lodash";
import "date-fns";
import axios from "axios";

//icons
import EqualizerIcon from "@material-ui/icons/Equalizer";
import PrintIcon from "@material-ui/icons/Print";

// components
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import Table from "./components/Table/Table";
//context
import { useVendorState } from "../../context/VendorContext";
import { tokenConfig } from "../../context/UserContext";

//helpers
import { BASE_URL } from "../../healpers/api";
import api from "../../healpers/apiRoutes";

import useStyles from "./styles";

export default function StrandedInventory(props) {
  const exportFunctionRef = useRef();
  const exportFunctionRef2 = useRef();
  //global
  const classes = useStyles();
  var vendorState = useVendorState();

  // local
  const [mainTableData, setmainTableData] = useState([]);
  const [aggTableData, setAggTableData] = useState([]);
  const [aggTableHeaders, setAggTableHeaders] = useState([]);
  const [fullPageLoader, setfullPageLoader] = useState(false);
  const [headerNames, setHeaderNames] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        setfullPageLoader(true);
        const response = await axios.get(
          BASE_URL + api.fbaReimbursements,
          tokenConfig({
            vendorCode: vendorState.selected,
          })
        );

        if (response?.data?.data) {
          const data = response.data.data;
          const filteredKeys = ["id", "createdAt", "vendorCode"];

          const headerNames = Object.keys(data[0])
            .filter((key) => filteredKeys.indexOf(key) < 0)
            .map((key) => {
              return {
                headerName: key
                  .replaceAll(/[A-Z]/g, (x) => ` ${x}`)
                  .replace(/^\w/g, (x) => x.toUpperCase()),
                field: key,
                columnWidth: 220,
              };
            });

          const aggObj = data.reduce((obj, curr) => {
            const { reason, amountTotal } = curr;
            obj[reason] = obj[reason] ? obj[reason] + amountTotal : amountTotal;
            obj["total"] = obj["total"]
              ? obj["total"] + amountTotal
              : amountTotal;
            return obj;
          }, {});

          const { total } = aggObj;

          delete aggObj.total;

          const aggData = [];
          for (const [key, value] of Object.entries(aggObj)) {
            aggData.push({
              reason: key,
              amountTotal: parseFloat(value.toFixed(2)),
            });
          }

          aggData.push({
            reason: "Total",
            amountTotal: parseFloat(total.toFixed(2)),
          });

          setAggTableHeaders([
            { headerName: "Reason", field: "reason", flex: 1 },
            {
              headerName: "Amount Reimbursed in $",
              field: "amountTotal",
              flex: 1,
            },
          ]);
          setAggTableData(aggData);
          setHeaderNames(headerNames);
          setmainTableData(data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setfullPageLoader(false);
      }
    }

    if (vendorState.selected) {
      fetchData();
    }

    return () => {
      setmainTableData([]);
    };
  }, [vendorState.selected]);

  return (
    <>
      <Container maxWidth={false}>
        <PageTitle
          title="FBA Reimbursements"
          breadCrump={
            <Breadcrumbs aria-label="breadcrumb">
              <Link color="inherit" className={classes.link}>
                SP Reports
              </Link>
              <Typography className={classes.link}>
                <EqualizerIcon color="primary" className={classes.icon} />
                FBA Reimbursements
              </Typography>
            </Breadcrumbs>
          }
        />
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Widget
              upperTitle
              noBodyPadding
              header={
                <>
                  <div className={classes.mainChartHeader}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      startIcon={<PrintIcon />}
                      onClick={() => exportFunctionRef2.current.onBtnExport()}
                    >
                      Export
                    </Button>
                  </div>
                </>
              }
            >
              <Table
                ref={exportFunctionRef2}
                tableData={aggTableData}
                headerNames={aggTableHeaders}
                classes={classes}
              />
            </Widget>
          </Grid>
          <Grid item xs={12}>
            <Widget
              upperTitle
              noBodyPadding
              header={
                <>
                  <div className={classes.mainChartHeader}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      startIcon={<PrintIcon />}
                      onClick={() => exportFunctionRef.current.onBtnExport()}
                    >
                      Export
                    </Button>
                  </div>
                </>
              }
            >
              <Table
                ref={exportFunctionRef}
                tableData={mainTableData}
                headerNames={headerNames}
                classes={classes}
              />
            </Widget>
          </Grid>
        </Grid>
        <Backdrop className={classes.backdrop} open={fullPageLoader}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </Container>
    </>
  );
}
